import { getMark } from '@jira/platform__performance/src/marks.tsx';
import { SPA_SSR_RENDERED } from '@jira/platform__providers-spa-apdex-analytics/src/constants.tsx';

export const getSSRMark = (): number | null => getMark(SPA_SSR_RENDERED)?.startTime || null;
